import { createSlice } from '@reduxjs/toolkit';
import { IRegionCommodityValues } from '../../Refactor/Components/MenuFileSelectors/MenuSelectorItem';
import type { RootState } from '../ReduxStore';

export type TableDefinitionSelections = { [key: string]: IRegionCommodityValues };

export interface MenuSelectionState {
    regionTopLevelSelections: TableDefinitionSelections;
    commodityTopLevelSelections: TableDefinitionSelections;
}

const initialState: MenuSelectionState = {
    regionTopLevelSelections: {},
    commodityTopLevelSelections: {},
};

export const menuSelectionSlice = createSlice({
    name: 'menuSelection',
    initialState,
    reducers: {
        setRegionTopLevelSelection: (state: MenuSelectionState, action: { payload: { tableDefinitionType: string; selections: IRegionCommodityValues } }) => {
            state.regionTopLevelSelections[action.payload.tableDefinitionType] = action.payload.selections;
        },
        setCommodityTopLevelSelection: (
            state: MenuSelectionState,
            action: { payload: { tableDefinitionType: string; selections: IRegionCommodityValues } },
        ) => {
            state.commodityTopLevelSelections[action.payload.tableDefinitionType] = action.payload.selections;
        },
    },
});

export const { setRegionTopLevelSelection, setCommodityTopLevelSelection } = menuSelectionSlice.actions;

export const selectRegionTopLevelSelections = (state: RootState) => state.menuSelection.regionTopLevelSelections;
export const selectCommodityTopLevelSelections = (state: RootState) => state.menuSelection.commodityTopLevelSelections;

export default menuSelectionSlice.reducer;
